import type { ObjectValues } from 'utils/types.ts';

export const HomepageTab = {
	POPULAR: 'popular',
	SAVED: 'saved',
	NEARBY: 'nearby',
	USED: 'usedGoods',
} as const;
export type HomepageTab = ObjectValues<typeof HomepageTab>;
